import { Link } from "react-router-dom";
import { ArrowRight, Broadcast, Stack, Path, ChartLineUp } from "@phosphor-icons/react";
import Layout, { PageHeader } from "../components/Layout";
import SEO from "../components/SEO";
import { Reveal, Stagger, StaggerItem } from "../components/motion";
import { StatusBadge } from "../components/StatusBadge";
import { OS_MODULES } from "../data/site";
import { IMAGES } from "../data/images";

const icons = [Broadcast, Stack, Path, ChartLineUp];

export default function EazymuvOS() {
  return (
    <Layout>
      <SEO title="Eazymuv OS" description="Eazymuv OS powers EazyOS — the Eazymuv Operating System that gives 100% visibility with a single operating view across factory, warehouse and logistics." />
      <PageHeader dark eyebrow="The Technology Ecosystem" title={<>Eazymuv <span className="text-ez-yellow">OS</span> — 100% visibility, one operating view</>} subtitle="EazyOS, the Eazymuv Operating System, connects managed operations and EazyMS — giving you a single, real-time operating view across factory, warehouse and logistics. 100% visibility." image={IMAGES.coldWarehouseCyan} imageAlt="Temperature-controlled warehouse" />
      <section className="bg-os-bg text-white grain relative">
        <div className="absolute inset-0 grid-bg-dark opacity-30" />
        <div className="relative max-w-[1600px] mx-auto px-5 md:px-8 py-20 md:py-28">
          <Stagger className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 border border-white/15 divide-y md:divide-y-0 md:divide-x divide-white/15">
            {OS_MODULES.map((m, i) => {
              const Icon = icons[i];
              return (
                <StaggerItem key={i} className="p-8 hover:bg-white/[0.04] transition-colors">
                  <div className="flex justify-between items-start mb-8">
                    <span className="font-mono-ez text-xs text-white/30">OS·0{i + 1}</span>
                    <StatusBadge status={m.status} />
                  </div>
                  <Icon size={32} weight="duotone" className="text-ez-yellow mb-6" />
                  <div className="font-display text-2xl uppercase tracking-tight">{m.name}</div>
                  <p className="mt-3 text-sm text-white/50">{m.desc}</p>
                </StaggerItem>
              );
            })}
          </Stagger>

          <div className="mt-20 grid grid-cols-1 lg:grid-cols-3 gap-px bg-white/15 border border-white/15">
            {[
              { t: "One connected view", d: "Managed operations, product and logistics in a single operating picture." },
              { t: "Floor-true data", d: "Instrumentation built from the shop floor, not bolted on after." },
              { t: "Network intelligence", d: "Cross-site insight that compounds as you expand.", tag: "Planned" },
            ].map((c, i) => (
              <div key={i} className="bg-os-bg p-10">
                <div className="font-display text-xl uppercase tracking-tight text-ez-yellow">{c.t}</div>
                <p className="mt-3 text-sm text-white/50">{c.d}</p>
                {c.tag && <div className="mt-4"><StatusBadge status={c.tag} /></div>}
              </div>
            ))}
          </div>

          <div className="mt-16">
            <Link to="/products" data-testid="os-cta" className="inline-flex items-center gap-2 bg-ez-yellow text-ez-text px-7 py-4 font-semibold hover:bg-white transition-colors">
              Explore the Products <ArrowRight size={18} weight="bold" />
            </Link>
          </div>
        </div>
      </section>
    </Layout>
  );
}
